import { init } from "../init-streaming";
import { EnterpriseContactSalesPage } from "../pages/enterprise/contact/enterprise-contact-sales-page";
init(EnterpriseContactSalesPage);
